window.EmberENV={ ...(window.EmberENV || {}), ...{
  "FEATURES": {},
  "_APPLICATION_TEMPLATE_WRAPPER": false,
  "_DEFAULT_ASYNC_OBSERVERS": true,
  "_JQUERY_INTEGRATION": false,
  "_TEMPLATE_ONLY_GLIMMER_COMPONENTS": true,
  "_USE_EMBER_MODULES": true
} };var runningTests=false;